import { useState } from "react";
import { SetPassword, Login } from "../index";
const FirsAccess = () => {
  const [isUserMakeAccess, setIsUserMakeAccess] = useState(false);
  const makeAccess = () => {
    setIsUserMakeAccess(true);
  };
  return (
    <>
      {!isUserMakeAccess ? (
        <SetPassword makeAccess={() => makeAccess()} />
      ) : (
        <Login first />
      )}
    </>
  );
};

export default FirsAccess;
